import { render, staticRenderFns } from "./pledgeTx.vue?vue&type=template&id=ec4feb6e&scoped=true&"
import script from "./pledgeTx.vue?vue&type=script&lang=js&"
export * from "./pledgeTx.vue?vue&type=script&lang=js&"
import style0 from "./pledgeTx.vue?vue&type=style&index=0&id=ec4feb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4feb6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec4feb6e')) {
      api.createRecord('ec4feb6e', component.options)
    } else {
      api.reload('ec4feb6e', component.options)
    }
    module.hot.accept("./pledgeTx.vue?vue&type=template&id=ec4feb6e&scoped=true&", function () {
      api.rerender('ec4feb6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/quota/pledgeTx.vue"
export default component.exports